/**
 * @fileoverview Pre-computed intro animation steps.
 * Generated by scripts/generate-intro-data.js
 * DO NOT EDIT MANUALLY
 */

export const introSteps = [
    {
        "type": "stop",
        "reels": [
            [
                {
                    "id": 2
                },
                {
                    "id": 2
                },
                {
                    "id": 7
                },
                {
                    "id": 7
                },
                {
                    "id": 4
                }
            ],
            [
                {
                    "id": 1
                },
                {
                    "id": 7
                },
                {
                    "id": 7
                },
                {
                    "id": 2
                },
                {
                    "id": 2
                }
            ],
            [
                {
                    "id": 4
                },
                {
                    "id": 1
                },
                {
                    "id": 1
                },
                {
                    "id": 10
                },
                {
                    "id": 4
                }
            ],
            [
                {
                    "id": 1
                },
                {
                    "id": 7
                },
                {
                    "id": 7
                },
                {
                    "id": 9
                },
                {
                    "id": 9
                }
            ],
            [
                {
                    "id": 4
                },
                {
                    "id": 8
                },
                {
                    "id": 8
                },
                {
                    "id": 7
                },
                {
                    "id": 7
                }
            ],
            [
                {
                    "id": 7
                },
                {
                    "id": 7
                },
                {
                    "id": 4
                },
                {
                    "id": 4
                },
                {
                    "id": 1
                }
            ]
        ]
    },
    {
        "type": "win",
        "positions": [
            {
                "row": 2,
                "column": 0
            },
            {
                "row": 3,
                "column": 0
            },
            {
                "row": 1,
                "column": 1
            },
            {
                "row": 2,
                "column": 1
            },
            {
                "row": 1,
                "column": 3
            },
            {
                "row": 2,
                "column": 3
            },
            {
                "row": 3,
                "column": 4
            },
            {
                "row": 4,
                "column": 4
            },
            {
                "row": 0,
                "column": 5
            },
            {
                "row": 1,
                "column": 5
            }
        ]
    },
    {
        "type": "destroy",
        "positions": [
            {
                "row": 2,
                "column": 0
            },
            {
                "row": 3,
                "column": 0
            },
            {
                "row": 1,
                "column": 1
            },
            {
                "row": 2,
                "column": 1
            },
            {
                "row": 1,
                "column": 3
            },
            {
                "row": 2,
                "column": 3
            },
            {
                "row": 3,
                "column": 4
            },
            {
                "row": 4,
                "column": 4
            },
            {
                "row": 0,
                "column": 5
            },
            {
                "row": 1,
                "column": 5
            }
        ]
    },
    {
        "type": "cascade",
        "movements": {
            "0": [
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "1": [
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "2": [],
            "3": [
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "4": [
                {
                    "fromRow": 2,
                    "toRow": 4
                },
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "5": []
        },
        "newSymbols": {
            "0": [
                {
                    "row": 0,
                    "symbolId": 1
                },
                {
                    "row": 1,
                    "symbolId": 1
                }
            ],
            "1": [
                {
                    "row": 0,
                    "symbolId": 9
                },
                {
                    "row": 1,
                    "symbolId": 1
                }
            ],
            "2": [],
            "3": [
                {
                    "row": 0,
                    "symbolId": 2
                },
                {
                    "row": 1,
                    "symbolId": 1
                }
            ],
            "4": [
                {
                    "row": 0,
                    "symbolId": 3
                },
                {
                    "row": 1,
                    "symbolId": 4
                }
            ],
            "5": [
                {
                    "row": 0,
                    "symbolId": 3
                },
                {
                    "row": 1,
                    "symbolId": 3
                }
            ]
        }
    },
    {
        "type": "win",
        "positions": [
            {
                "row": 0,
                "column": 0
            },
            {
                "row": 1,
                "column": 0
            },
            {
                "row": 1,
                "column": 1
            },
            {
                "row": 2,
                "column": 1
            },
            {
                "row": 1,
                "column": 2
            },
            {
                "row": 2,
                "column": 2
            },
            {
                "row": 1,
                "column": 3
            },
            {
                "row": 2,
                "column": 3
            },
            {
                "row": 4,
                "column": 5
            }
        ]
    },
    {
        "type": "destroy",
        "positions": [
            {
                "row": 0,
                "column": 0
            },
            {
                "row": 1,
                "column": 0
            },
            {
                "row": 1,
                "column": 1
            },
            {
                "row": 2,
                "column": 1
            },
            {
                "row": 1,
                "column": 2
            },
            {
                "row": 2,
                "column": 2
            },
            {
                "row": 1,
                "column": 3
            },
            {
                "row": 2,
                "column": 3
            },
            {
                "row": 4,
                "column": 5
            }
        ]
    },
    {
        "type": "cascade",
        "movements": {
            "0": [],
            "1": [
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "2": [
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "3": [
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "4": [],
            "5": [
                {
                    "fromRow": 3,
                    "toRow": 4
                },
                {
                    "fromRow": 2,
                    "toRow": 3
                },
                {
                    "fromRow": 1,
                    "toRow": 2
                },
                {
                    "fromRow": 0,
                    "toRow": 1
                }
            ]
        },
        "newSymbols": {
            "0": [
                {
                    "row": 0,
                    "symbolId": 4
                },
                {
                    "row": 1,
                    "symbolId": 4
                }
            ],
            "1": [
                {
                    "row": 0,
                    "symbolId": 11,
                    "multiplier": 100
                },
                {
                    "row": 1,
                    "symbolId": 9
                }
            ],
            "2": [
                {
                    "row": 0,
                    "symbolId": 2
                },
                {
                    "row": 1,
                    "symbolId": 4
                }
            ],
            "3": [
                {
                    "row": 0,
                    "symbolId": 4
                },
                {
                    "row": 1,
                    "symbolId": 2
                }
            ],
            "4": [],
            "5": [
                {
                    "row": 0,
                    "symbolId": 9
                }
            ]
        }
    },
    {
        "type": "win",
        "positions": [
            {
                "row": 0,
                "column": 0
            },
            {
                "row": 1,
                "column": 0
            },
            {
                "row": 4,
                "column": 0
            },
            {
                "row": 1,
                "column": 2
            },
            {
                "row": 2,
                "column": 2
            },
            {
                "row": 4,
                "column": 2
            },
            {
                "row": 0,
                "column": 3
            },
            {
                "row": 1,
                "column": 4
            },
            {
                "row": 2,
                "column": 4
            },
            {
                "row": 3,
                "column": 5
            },
            {
                "row": 4,
                "column": 5
            }
        ]
    },
    {
        "type": "destroy",
        "positions": [
            {
                "row": 0,
                "column": 0
            },
            {
                "row": 1,
                "column": 0
            },
            {
                "row": 4,
                "column": 0
            },
            {
                "row": 1,
                "column": 2
            },
            {
                "row": 2,
                "column": 2
            },
            {
                "row": 4,
                "column": 2
            },
            {
                "row": 0,
                "column": 3
            },
            {
                "row": 1,
                "column": 4
            },
            {
                "row": 2,
                "column": 4
            },
            {
                "row": 3,
                "column": 5
            },
            {
                "row": 4,
                "column": 5
            }
        ]
    },
    {
        "type": "cascade",
        "movements": {
            "0": [
                {
                    "fromRow": 3,
                    "toRow": 4
                },
                {
                    "fromRow": 2,
                    "toRow": 3
                }
            ],
            "1": [],
            "2": [
                {
                    "fromRow": 3,
                    "toRow": 4
                },
                {
                    "fromRow": 0,
                    "toRow": 3
                }
            ],
            "3": [],
            "4": [
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "5": [
                {
                    "fromRow": 2,
                    "toRow": 4
                },
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ]
        },
        "newSymbols": {
            "0": [
                {
                    "row": 0,
                    "symbolId": 8
                },
                {
                    "row": 1,
                    "symbolId": 3
                },
                {
                    "row": 2,
                    "symbolId": 3
                }
            ],
            "1": [],
            "2": [
                {
                    "row": 0,
                    "symbolId": 3
                },
                {
                    "row": 1,
                    "symbolId": 3
                },
                {
                    "row": 2,
                    "symbolId": 2
                }
            ],
            "3": [
                {
                    "row": 0,
                    "symbolId": 4
                }
            ],
            "4": [
                {
                    "row": 0,
                    "symbolId": 8
                },
                {
                    "row": 1,
                    "symbolId": 3
                }
            ],
            "5": [
                {
                    "row": 0,
                    "symbolId": 11,
                    "multiplier": 100
                },
                {
                    "row": 1,
                    "symbolId": 9
                }
            ]
        }
    },
    {
        "type": "win",
        "positions": [
            {
                "row": 1,
                "column": 0
            },
            {
                "row": 2,
                "column": 0
            },
            {
                "row": 3,
                "column": 0
            },
            {
                "row": 4,
                "column": 0
            },
            {
                "row": 3,
                "column": 1
            },
            {
                "row": 4,
                "column": 1
            },
            {
                "row": 0,
                "column": 2
            },
            {
                "row": 1,
                "column": 2
            },
            {
                "row": 2,
                "column": 2
            },
            {
                "row": 3,
                "column": 2
            },
            {
                "row": 1,
                "column": 3
            },
            {
                "row": 2,
                "column": 3
            },
            {
                "row": 1,
                "column": 4
            },
            {
                "row": 2,
                "column": 4
            },
            {
                "row": 3,
                "column": 5
            },
            {
                "row": 4,
                "column": 5
            }
        ]
    },
    {
        "type": "destroy",
        "positions": [
            {
                "row": 1,
                "column": 0
            },
            {
                "row": 2,
                "column": 0
            },
            {
                "row": 3,
                "column": 0
            },
            {
                "row": 4,
                "column": 0
            },
            {
                "row": 3,
                "column": 1
            },
            {
                "row": 4,
                "column": 1
            },
            {
                "row": 0,
                "column": 2
            },
            {
                "row": 1,
                "column": 2
            },
            {
                "row": 2,
                "column": 2
            },
            {
                "row": 3,
                "column": 2
            },
            {
                "row": 1,
                "column": 3
            },
            {
                "row": 2,
                "column": 3
            },
            {
                "row": 1,
                "column": 4
            },
            {
                "row": 2,
                "column": 4
            },
            {
                "row": 3,
                "column": 5
            },
            {
                "row": 4,
                "column": 5
            }
        ]
    },
    {
        "type": "cascade",
        "movements": {
            "0": [
                {
                    "fromRow": 0,
                    "toRow": 4
                }
            ],
            "1": [
                {
                    "fromRow": 2,
                    "toRow": 4
                },
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "2": [],
            "3": [
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "4": [
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "5": [
                {
                    "fromRow": 2,
                    "toRow": 4
                },
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ]
        },
        "newSymbols": {
            "0": [
                {
                    "row": 0,
                    "symbolId": 11,
                    "multiplier": 100
                },
                {
                    "row": 1,
                    "symbolId": 1
                },
                {
                    "row": 2,
                    "symbolId": 1
                },
                {
                    "row": 3,
                    "symbolId": 8
                }
            ],
            "1": [
                {
                    "row": 0,
                    "symbolId": 8
                },
                {
                    "row": 1,
                    "symbolId": 8
                }
            ],
            "2": [
                {
                    "row": 0,
                    "symbolId": 6
                },
                {
                    "row": 1,
                    "symbolId": 6
                },
                {
                    "row": 2,
                    "symbolId": 8
                },
                {
                    "row": 3,
                    "symbolId": 8
                }
            ],
            "3": [
                {
                    "row": 0,
                    "symbolId": 7
                },
                {
                    "row": 1,
                    "symbolId": 11,
                    "multiplier": 100
                }
            ],
            "4": [
                {
                    "row": 0,
                    "symbolId": 2
                },
                {
                    "row": 1,
                    "symbolId": 8
                }
            ],
            "5": [
                {
                    "row": 0,
                    "symbolId": 8
                },
                {
                    "row": 1,
                    "symbolId": 8
                }
            ]
        }
    },
    {
        "type": "win",
        "positions": [
            {
                "row": 3,
                "column": 0
            },
            {
                "row": 4,
                "column": 0
            },
            {
                "row": 0,
                "column": 1
            },
            {
                "row": 1,
                "column": 1
            },
            {
                "row": 2,
                "column": 2
            },
            {
                "row": 3,
                "column": 2
            },
            {
                "row": 1,
                "column": 4
            },
            {
                "row": 2,
                "column": 4
            },
            {
                "row": 3,
                "column": 4
            },
            {
                "row": 4,
                "column": 4
            },
            {
                "row": 0,
                "column": 5
            },
            {
                "row": 1,
                "column": 5
            }
        ]
    },
    {
        "type": "destroy",
        "positions": [
            {
                "row": 3,
                "column": 0
            },
            {
                "row": 4,
                "column": 0
            },
            {
                "row": 0,
                "column": 1
            },
            {
                "row": 1,
                "column": 1
            },
            {
                "row": 2,
                "column": 2
            },
            {
                "row": 3,
                "column": 2
            },
            {
                "row": 1,
                "column": 4
            },
            {
                "row": 2,
                "column": 4
            },
            {
                "row": 3,
                "column": 4
            },
            {
                "row": 4,
                "column": 4
            },
            {
                "row": 0,
                "column": 5
            },
            {
                "row": 1,
                "column": 5
            }
        ]
    },
    {
        "type": "cascade",
        "movements": {
            "0": [
                {
                    "fromRow": 2,
                    "toRow": 4
                },
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "1": [],
            "2": [
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "3": [],
            "4": [
                {
                    "fromRow": 0,
                    "toRow": 4
                }
            ],
            "5": []
        },
        "newSymbols": {
            "0": [
                {
                    "row": 0,
                    "symbolId": 4
                },
                {
                    "row": 1,
                    "symbolId": 4
                }
            ],
            "1": [
                {
                    "row": 0,
                    "symbolId": 3
                },
                {
                    "row": 1,
                    "symbolId": 3
                }
            ],
            "2": [
                {
                    "row": 0,
                    "symbolId": 9
                },
                {
                    "row": 1,
                    "symbolId": 9
                }
            ],
            "3": [],
            "4": [
                {
                    "row": 0,
                    "symbolId": 6
                },
                {
                    "row": 1,
                    "symbolId": 6
                },
                {
                    "row": 2,
                    "symbolId": 11,
                    "multiplier": 100
                },
                {
                    "row": 3,
                    "symbolId": 2
                }
            ],
            "5": [
                {
                    "row": 0,
                    "symbolId": 2
                },
                {
                    "row": 1,
                    "symbolId": 2
                }
            ]
        }
    },
    {
        "type": "win",
        "positions": [
            {
                "row": 3,
                "column": 1
            },
            {
                "row": 4,
                "column": 1
            },
            {
                "row": 0,
                "column": 2
            },
            {
                "row": 1,
                "column": 2
            },
            {
                "row": 3,
                "column": 3
            },
            {
                "row": 4,
                "column": 3
            },
            {
                "row": 3,
                "column": 5
            },
            {
                "row": 4,
                "column": 5
            }
        ]
    },
    {
        "type": "destroy",
        "positions": [
            {
                "row": 3,
                "column": 1
            },
            {
                "row": 4,
                "column": 1
            },
            {
                "row": 0,
                "column": 2
            },
            {
                "row": 1,
                "column": 2
            },
            {
                "row": 3,
                "column": 3
            },
            {
                "row": 4,
                "column": 3
            },
            {
                "row": 3,
                "column": 5
            },
            {
                "row": 4,
                "column": 5
            }
        ]
    },
    {
        "type": "cascade",
        "movements": {
            "0": [],
            "1": [
                {
                    "fromRow": 2,
                    "toRow": 4
                },
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "2": [],
            "3": [
                {
                    "fromRow": 2,
                    "toRow": 4
                },
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ],
            "4": [],
            "5": [
                {
                    "fromRow": 2,
                    "toRow": 4
                },
                {
                    "fromRow": 1,
                    "toRow": 3
                },
                {
                    "fromRow": 0,
                    "toRow": 2
                }
            ]
        },
        "newSymbols": {
            "0": [],
            "1": [
                {
                    "row": 0,
                    "symbolId": 2
                },
                {
                    "row": 1,
                    "symbolId": 2
                }
            ],
            "2": [
                {
                    "row": 0,
                    "symbolId": 8
                },
                {
                    "row": 1,
                    "symbolId": 8
                }
            ],
            "3": [
                {
                    "row": 0,
                    "symbolId": 1
                },
                {
                    "row": 1,
                    "symbolId": 7
                }
            ],
            "4": [],
            "5": [
                {
                    "row": 0,
                    "symbolId": 3
                },
                {
                    "row": 1,
                    "symbolId": 3
                }
            ]
        }
    },
    {
        "type": "multiplier",
        "multipliers": [
            {
                "row": 2,
                "column": 0,
                "multiplier": 100
            },
            {
                "row": 4,
                "column": 1,
                "multiplier": 100
            },
            {
                "row": 3,
                "column": 3,
                "multiplier": 100
            },
            {
                "row": 2,
                "column": 4,
                "multiplier": 100
            },
            {
                "row": 4,
                "column": 5,
                "multiplier": 100
            }
        ],
        "totalMultiplier": 500
    },
    {
        "type": "spin"
    }
];
